import {api} from '../../api';
import {createMutation} from '../../lib';

const {putContractsCidDocumentUpdate} = api.contracts;

export const usePutContractsCidDocumentUpdateMutation = createMutation(
  (params: Parameters<typeof putContractsCidDocumentUpdate>) => putContractsCidDocumentUpdate(...params),
);
